// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"errorModal_mulitpleDropdown__1CQpA","modalWrapper":"errorModal_modalWrapper__3dAFE"};